import { Observable, Subject } from 'rxjs';

/** @internal Token to access internal dismiss on SnackbarRef */
export const SNACKBAR_DISMISS = Symbol('snackbar-dismiss');

export class SnackbarRef {
  private readonly actionSubject = new Subject<void>();
  private readonly dismissSubject = new Subject<void>();
  private dismissed = false;

  onAction(): Observable<void> {
    return this.actionSubject.asObservable();
  }

  afterDismissed(): Observable<void> {
    return this.dismissSubject.asObservable();
  }

  dismiss(): void {
    this.internalDismiss();
  }

  dismissWithAction(): void {
    this.actionSubject.next();
    this.actionSubject.complete();
    this.internalDismiss();
  }

  /** @internal Only accessible via SNACKBAR_DISMISS symbol */
  [SNACKBAR_DISMISS](): void {
    this.internalDismiss();
  }

  private internalDismiss(): void {
    if (!this.dismissed) {
      this.dismissed = true;
      this.dismissSubject.next();
      this.dismissSubject.complete();
      this.actionSubject.complete();
    }
  }
}
